import { getExportAndAccessRequestDetailsPath } from 'modules/requests/requestDetailPaths'
import type { Result } from 'services/results/types'
import { formatDate } from 'utils/date'

interface UsePreviousAppealApprovalDetailsProps {
  result: Result
}

const usePreviousAppealApprovalDetails = ({ result }: UsePreviousAppealApprovalDetailsProps) => {
  const previousRequest = result.appealReview?.previousRequest

  const firstOriginalRequestIdentifierUrl = previousRequest?._id
    ? getExportAndAccessRequestDetailsPath(previousRequest._id)
    : getExportAndAccessRequestDetailsPath('-')
  const originallyRejectedBy = previousRequest?.verifiedBy?.email ?? '-'
  const originalRejectionDate = formatDate(previousRequest?.verifiedAt)

  return {
    cardTitle: 'Previously Rejected Request',
    firstOriginalRequestIdentifierUrl,
    originallyRejectedBy,
    originalRejectionDate,
    reasonForRejection: previousRequest?.rejectionReason ?? '-'
  }
}

export default usePreviousAppealApprovalDetails
